//Todo: add media queries for widths
import classNames from 'classnames'
import { FC } from 'react'
import './index.less'

interface ContentContainerProps {
  collapsed?: boolean
  fullHeight?: boolean
}

export const ContentContainer: FC<ContentContainerProps> = ({ fullHeight, collapsed = false, children }) => {
  return (
    <div
      className={classNames({
        'content-container': true,
        fullHeight: fullHeight,
        'per-aside-collapsed': collapsed,
      })}
      id="content-container"
    >
      {children}
    </div>
  )
}
